import React from 'react';
import API from "../../../Services/BaseService";
import { useHistory } from "react-router-dom";
import ls from 'local-storage';
import { useState } from 'react';
import { useEffect } from 'react';
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import StateAndCity from '../../../Component/StateAndCity/StateAndCity';
import { useForm } from "react-hook-form";
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks";
import PhoneInput from 'react-phone-number-input/input';
import { useSelector } from 'react-redux';
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import PhoneInputs from 'react-phone-input-2'
import StateAndCitySearch from '../../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../../FallBackUI/PageNotFound';
import { Button } from 'antd';

const AddAddress = () => {
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("")

    const userDetails = ls.get('userDetails');
    const [firstName, setFirstname] = useState("");
    const [lastName, setLastname] = useState("");
    const [address, setAddress] = useState("");
    const [primaryPhone, setPrimaryphone] = useState("");
    const [mobilePhone, setMobilephone] = useState("");
    const [cityName, setCityName] = useState("");
    const [stateName, setStateName] = useState("");
    const [zipCodeId, setZipcodeId] = useState("");
    const [location, setLocation] = useState("");
    const [instruction, setInstruction] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [primaryPhoneError, setPrimaryphoneError] = useState("");
    const [mobilePhoneError, setMobilephoneError] = useState("");
    const [stateAndCityError, setStateAndCityError] = useState("");
    const [locationError, setLocationError] = useState("");
    const [instructionError, setInstructionError] = useState("");
    const [state, setState] = useState("1");
    const [city, setCity] = useState("1");
    const [zipcode, setZipcode] = useState("1");

    const [idStatename, setIdStatename] = useState(null);
    const [idCityname, setIdCityname] = useState(null);
    const [idZipcodename, setidZipcodename] = useState(null);
    const [stateCityFlag, setStateCityFlag] = useState("");
    const successData = useSelector(state => state.LoginReducer.payload);
    const [changesFlag, setChangesFlag] = useState("no");

    const [addErrors, setAddErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const [confirmationFlag, setConfirmationFlag] = useState(false);
    const [extentation, setExtentation] = useState("");
    const [extentationmob, setExtentationmob] = useState("");
    const [optionPhone, setOptionPhone] = useState("");
    const [optionPhone1, setOptionPhone1] = useState("");
    const [country, setCountry] = useState("");
    const [changesArray, setChangesArray] = useState([]);
    console.log("changesArray", changesArray);
    const confirmationPopup = () => {

        setConfirmationFlag(!confirmationFlag)

    }

    const customButtonStyle = {
        backgroundColor: "RGB(189,6,44)",
        color: "white",
        height: '40px'
    };
    useEffect(() => fetchCountry()
        , [])

    async function fetchCountry() {
        const country = API.get('country');
        country.then((response) => {

            if (response.data.success === true) {
                setCountry(response.data.data);
            }
            else {
                setAddErrors(response.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setAddErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }
    function formatMobileNO(value) {
        var x = value.replace(/\D/g, '').match(/(\d{1})(\d{3})(\d{3})(\d{4})/);

        console.log("value of x", x);
        value = '+' + x[1] + '(' + x[2] + ')' + x[3] + '-' + x[4];
        console.log("mobileno", value);
        return value;
    }

    useEffect(() => {
        setIdStatename(idStatename)
        setIdCityname(idCityname)
        setidZipcodename(idZipcodename)
    }, []);

    const onhandleSubmit = () => {
        // setOpenLoader(true);
        // event.preventDefault();        
        setFirstNameError("")
        setLastNameError("")
        setPrimaryphoneError("")
        setMobilephoneError("")
        setAddressError("")
        setStateAndCityError("")
        setLocationError("")
        setInstructionError("")

        if (!firstName) {
            setFirstNameError("First Name is required")
            return;
        }
        else if (firstName.length > 50) {
            setFirstNameError("First Name must not exceed 50 characters")
            return;
        }
        if (!lastName) {
            setLastNameError("Last Name is required")
            return;
        }
        else if (lastName.length > 50) {
            setLastNameError("Last Name must not exceed 50 characters ")
            return;
        }
        if (!primaryPhone) {
            setPrimaryphoneError("Phone Number is required")
            return;
        }
        else if (primaryPhone.length < 10) {
            setPrimaryphoneError("Phone Number must have 10 digits ")
            return;
        }
        if (!mobilePhone) {
            setMobilephoneError("Mobile Phone Number is required")
            return;
        }
        else if (mobilePhone.length < 10) {
            console.log("phone=======", mobilePhone.length)
            setMobilephoneError("Mobile Phone Number must have 10 digits ")
            return;
        }
        if (!address) {
            setAddressError("Address is required")
            return;
        }
        else if (address.length > 150) {
            setAddressError("Address must not exceed 150 characters")
            return;
        }
        if (!idStatename) {
            setStateAndCityError("1")
            return
        }
        if (!idCityname) {
            setStateAndCityError("2")
            return
        }
        if (!idZipcodename) {
            setStateAndCityError("3")
            return
        }
        if (!location) {
            setLocationError("Location is required")
            return;
        }
        else if (location.length > 150) {
            setLocationError("Location must not exceed 150 characters")
            return;
        }
        if (!instruction) {
            setInstructionError("Instruction is required")
            return;
        }
        else if (instruction.length > 150) {
            setInstructionError("Instruction must not exceed 150 characters ")
            return;
        }
        const filteredChangesArray = changesArray.filter(change => !(change.oldvalue === ''&&change.newvalue === ''));

        let request = {
            first_name: firstName,
            last_name: lastName,
            address: address,
            phone_no: primaryPhone,
            mobile_no: mobilePhone,

            state_id: stateCityFlag === "" ? idStatename : "",
            city_id: stateCityFlag === "" ? idCityname : "",
            zipcode_id: stateCityFlag === "" ? idZipcodename : "",
            state_name: stateCityFlag !== "" ? idStatename : "",
            city_name: stateCityFlag !== "" ? idCityname : "",
            zipcode: stateCityFlag !== "" ? idZipcodename : "",

            // city_id: cityName,
            // state_id: stateName,
            // zipcode_id: zipCodeId,
            seller_dealer_id: successData.seller_dealer_id,
            location: location,
            instructions: instruction,
            active: 1,
            createdBy: successData.seller_id,
            updatedBy: successData.seller_id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
            historylist: filteredChangesArray,
            extentation: extentation == null || extentation == "null" ? "" : extentation,
            mobile_extentation: extentationmob == null || extentationmob == "null" ? "" : extentationmob,
            country_code: optionPhone,
            mobile_country_code: optionPhone1,

        };
        console.log("===", request)
        API.post("seller_address/add", request)
            .then((response) => {
                if (response.data.success) {
                    const { data } = response;
                    togglePopup()
                    setPopupTitle("Create Address");
                    setPopupMsg("Address is successfully created");
                    setPopupType("success");
                    setPopupActionType("redirect");
                    setPopupActionValue("ok");
                    setPopupActionPath("/manageaccount")

                } else {
                    togglePopup()
                    setPopupTitle("Create Address");
                    // setPopupMsg("Address is not Created, Please try Again");
                    setPopupMsg(response.data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            }, (error) => {
                // setOpenLoader(false);
                // console.log(error);
                togglePopup()
                setPopupTitle("Error");
                setPopupMsg("Something went wrong, Please try Again");
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            })
            .catch(function (error) {
                if (error.response) {
                    setAddErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const getStateName = (stateData, flag, type) => {
        setIdStatename(stateData)
        setStateCityFlag(flag)
        if (flag === "") {
            setIdCityname(null)
            setidZipcodename(null)
        }
        const newValue = stateData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: type };
                return updatedChangesArray;
            } else {
                const change = { oldvalue, newvalue: newValue, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getCityName = (cityData, flag, type) => {
        setIdCityname(cityData)
        if (flag === "") {
            setidZipcodename(null)
        }
        const newValue = cityData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: type };
                return updatedChangesArray;
            } else {
                const change = { oldvalue, newvalue: newValue, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getZipCodeId = (zipData, type) => {
        setidZipcodename(zipData)
        const newValue = zipData;
        const oldvalue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: type };
                return updatedChangesArray;
            } else {
                const change = { oldvalue, newvalue: newValue, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getError = (data, flag) => {
        console.log("reg flag", data, flag);
        setAddErrors(data)
        setErrorFlag(flag)
    }



    function handleOnChange(value) {
        setPrimaryphone(value);
    }
    function handleOnChanges(value) {
        setMobilephone(value);
    }

    const handleFirstnameChange = (e) => {
        const newValue = e.target.value;
        setFirstname(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'firstName');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "FirstName Added As " + newValue, name: 'firstName' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "FirstName Added As " + newValue, name: 'firstName' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleLastnameChange = (e) => {
        const newValue = e.target.value;
        setLastname(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'lastName');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "LastName Added As " + newValue, name: 'lastName' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "LastName Added As " + newValue, name: 'lastName' };
            setChangesArray([...changesArray, change]);
        }
    }
    function handleOnChange(e) {
        const newValue = e;
        setPrimaryphone(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'phone');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "Phone Number Added As " + newValue, name: 'phone' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "Phone Number Added As " + newValue, name: 'phone' };
            setChangesArray([...changesArray, change]);
        }
    }

    function handleOnChanges(e) {
        const newValue = e;
        setMobilephone(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'mobilePhone');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "MobilePhone Number Added As " + newValue, name: 'mobilePhone' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "MobilePhone Number Added As " + newValue, name: 'mobilePhone' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleExtentationChange = (e) => {
        const newValue = e.target.value;

        setExtentation(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Extentaion');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "Extentaion  Added As " + newValue, name: 'Extentaion' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "Extentaion  Added As " + newValue, name: 'Extentaion' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleAddressChange = (e) => {
        const newValue = e.target.value;
        setAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "Address Added As " + newValue, name: 'Address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "Address Added As " + newValue, name: 'Address' };
            setChangesArray([...changesArray, change]);
        }
    }
    
    const handleLocationChange = (e) => {
        const newValue = e.target.value;
        setLocation(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Location');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "Location Added As " + newValue, name: 'Location' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "Location Added As " + newValue, name: 'Location' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleInstructionChange = (e) => {
        const newValue = e.target.value;
        setInstruction(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Instruction');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { newvalue: "Instruction Added As " + newValue, name: 'Instruction' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { newvalue: "Instruction Added As " + newValue, name: 'Instruction' };
            setChangesArray([...changesArray, change]);
        }
    }

    const handleLables = (e, label) => {
        setChangesFlag("yes")
        if (label === "Primary Phone # Extension") {
            console.log("check the changing value");
            // const oldvalue = accountObjc?.extentation;
            // const data = value.replace(/\D/g, "");
            // setExtentation(data)  
            const newValue = e;
            setExtentation(newValue);

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: "Primary Phone # Extension Added As " + newValue, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { newValue: "Primary Phone # Extension Added As " + newValue, name: "Primary Phone # Extension" };
                setChangesArray([...changesArray, change]);
            }

        }
        if (label === "Primary Phone # Country Code") {
            console.log("check the changing value");
            const oldvalue = "";
            const data = e;
            setOptionPhone(data)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: "Primary Phone # Country Code Added As " + data, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { newValue: "Primary Phone # Country Code Added As " + data, name: "Primary Phone # Country Code" };
                setChangesArray([...changesArray, change]);
            }

        }
        if (label === "Mobile Phone # Country Code") {
            console.log("check the changing value");
            const oldvalue = "";
            const data = e;
            setOptionPhone1(data)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: "Mobile Phone # Country Code Added As " + data, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { newValue: "Mobile Phone # Country Code Added As " + data, name: "Mobile Phone # Country Code" };
                setChangesArray([...changesArray, change]);
            }

        }
    }

    const handleMobileLables = (e, label) => {
        setChangesFlag("yes")
        if (label === "Mobile Phone # Extension") {
            console.log("check the changing value");
            const newValue = e;
            setExtentationmob(newValue);

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { newvalue: "Mobile Phone # Extension Added As " + newValue, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { newValue: "Mobile Phone # Extension Added As " + newValue, name: "Mobile Phone # Extension" };
                setChangesArray([...changesArray, change]);
            }

        }
    }

    return (
        <div>

            <main id="main" className="inner-page">
                {errorFlag === true ? <PageNotFound error={addErrors} /> :
                    <div id="addaddress" className="addaddress_block">
                        <div className="container" >
                            <div className="addaddressblock col-lg-12">
                                <div className="section-title">
                                    <h2>Add Address</h2>
                                </div>
                                <div className="row content">
                                    <div className="col-lg-3 col-md-4 col-sm-12 mgaccountleftblock">

                                        <ManageAccountLinks />
                                    </div>
                                    <div className="col-lg-9 col-md-8 col-sm-12 pt-4 pt-lg-0 flooraddform">
                                        <div className="adduserpage-inner">
                                            <div className="col-lg-12">
                                                <form className="registrationform" >

                                                    <div className="row">

                                                        <div className="section-title">
                                                            <button className="back-btn-paymentform backBtn" onClick={() => history.push("/manageaccount")}><i className="icofont-arrow-left"></i> Back</button>
                                                            <h2>Add Address </h2>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="firstName" className="textbox" placeholder="" name="firstName"
                                                                    /* onChange={(e) => setFirstname(e.target.value)} */ onChange={handleFirstnameChange} />
                                                                <label htmlFor="firstName" className={firstName != "" ? "input-has-value required" : "required"}>First Name</label>
                                                                <p className="form-input-error" >{firstNameError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="lastName" className="textbox" placeholder="" name="lastName"
                                                                   /*  onChange={(e) => setLastname(e.target.value)} */ onChange={handleLastnameChange} />
                                                                <label htmlFor="lastName" className={lastName != "" ? "input-has-value required" : "required"}>Last Name</label>
                                                                <p className="form-input-error" >{lastNameError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4 form-group countrycode">
                                                            <div className="tbox">
                                                                <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                                                                    onChange={(e) => { handleLables(e.target.value, "Primary Phone # Country Code") }} value={optionPhone}
                                                                >
                                                                    <option style={{ display: "none" }}>{optionPhone}</option>
                                                                    {country.length > 0 &&
                                                                        <>
                                                                            {country.map((country) => <>
                                                                                <option key={country.id} value={`+${country.country_code}`} >
                                                                                    {country?.country_name}({`+${country.country_code}`})
                                                                                </option>
                                                                            </>)}
                                                                        </>}
                                                                </select>
                                                                <label for="drop" className={"input-has-value"}>Country Code</label>

                                                            </div>
                                                        </div>

                                                        <div className="col-sm-5 form-group ">
                                                            <div className="tbox ">
                                                                {/* <PhoneInput  id="primaryPhone" name="primaryPhone" country="US" class="textbox" maxLength="14" minLength="14" value={primaryPhone}
                                onChange={handleOnChange} ></PhoneInput> */}
                                                                <PhoneInputs
                                                                    className="textbox"
                                                                    country={'us'}
                                                                    disableDropdown={true}
                                                                    disableCountryCode={true}
                                                                    onlyCountries={['us']}
                                                                    value={primaryPhone}
                                                                    onChange={(data) => handleOnChange(data)}
                                                                    placeholder=""
                                                                ></PhoneInputs>
                                                                <label htmlFor="primaryPhone" className={"input-has-value required"}>Primary Phone #</label>
                                                                <p className="form-input-error" >{primaryPhoneError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-3 form-group">
                                                            <div className="tbox extn-code">
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    id="extentation1"
                                                                    // value={extentation}
                                                                    onChange={(e) => { handleLables(e.target.value, "Primary Phone # Extension"); }}

                                                                />
                                                                <label for="drop" className={"input-has-value"}>Extension</label>

                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4 form-group countrycode">
                                                            <div className="tbox">
                                                                <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                                                                    onChange={(e) => { handleLables(e.target.value, "Mobile Phone # Country Code") }} value={optionPhone1}
                                                                >
                                                                    <option style={{ display: "none" }}>{optionPhone1}</option>
                                                                    {country.length > 0 &&
                                                                        <>
                                                                            {country.map((country) => <>
                                                                                <option key={country.id} value={`+${country.country_code}`} >
                                                                                    {country?.country_name}({`+${country.country_code}`})
                                                                                </option>
                                                                            </>)}
                                                                        </>}
                                                                </select>
                                                                <label for="drop" className={"input-has-value"}>Country Code</label>

                                                            </div>
                                                        </div>
                                                        <div className="col-sm-5 form-group ">
                                                            <div className="tbox ">

                                                                {/* <PhoneInput id="branchName" name="mobilePhone" country="US" class="textbox" maxLength="14" minLength="14" value={mobilePhone}
                                                                onChange={handleOnChanges} ></PhoneInput> */}
                                                                <PhoneInputs
                                                                    className="textbox"
                                                                    country={'us'}
                                                                    disableDropdown={true}
                                                                    disableCountryCode={true}
                                                                    onlyCountries={['us']}
                                                                    value={mobilePhone}
                                                                    onChange={(data) => handleOnChanges(data)}
                                                                    placeholder=""
                                                                ></PhoneInputs>
                                                                <label htmlFor="branchName" className={"input-has-value required"}>Mobile Phone #</label>
                                                                <p className="form-input-error" >{mobilePhoneError}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-3 form-group">
                                                            <div className="tbox extn-code">
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    id="extentation1"
                                                                    value={extentationmob}
                                                                    onChange={(e) => { handleMobileLables(e.target.value, "Mobile Phone # Extension"); }}

                                                                />
                                                                <label for="drop" className={"input-has-value"}>Extension</label>

                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="address" className="textbox" placeholder="" name="address"
                                                                    /* onChange={(e) => setAddress(e.target.value)}  */ onChange={handleAddressChange} />
                                                                <label htmlFor="address" className={address != "" ? "input-has-value required" : "required"}>Address</label>
                                                                <p className="form-input-error" >{addressError}</p>
                                                            </div>
                                                        </div>
                                                        <StateAndCitySearch
                                                            // setStateValue={getStateName}
                                                            // setCityValue={getCityName}
                                                            // setZipcodeValue={getZipCodeId}
                                                            setStateValue={(stateData, flag) => getStateName(stateData, flag, "Bank State")}
                                                            setCityValue={(cityData, flag) => getCityName(cityData, flag, "Bank City")}
                                                            setZipcodeValue={(zipData) => getZipCodeId(zipData, "Bank Zipcode")}
                                                            setNewError={getError}
                                                            stateCityValidation={stateAndCityError}
                                                            setRequired="true"

                                                        />
                                                        {/* <div className="col-sm-12 form-group">
                                                        <p className="form-input-error2"> {stateAndCityError}</p>
                                                    </div> */}

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="location" className="textbox" placeholder="" name="location"
                                                                    /* onChange={(e) => setLocation(e.target.value)} */ onChange={handleLocationChange} />
                                                                <label htmlFor="location" className={location != "" ? "input-has-value required" : "required"}>Location</label>
                                                                <p className="form-input-error" >{locationError}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" id="instruction" className="textbox" placeholder="" name="instruction" autoComplete="off"
                                                                    /* onChange={(e) => setInstruction(e.target.value)} */ onChange={handleInstructionChange} />
                                                                <label htmlFor="instruction" className={instruction != "" ? "input-has-value required" : "required"}>Instructions</label>
                                                                <p className="form-input-error" >{instructionError}</p>
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" id="accountNumber" className="textbox" placeholder="" required onChange={(e) => setCity(e.target.value)} />
                                <label for="accountNumber" className={city !="" ? "input-has-value" : ""}>City</label>
                            </div>
                            </div>
                           
                            <div className="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" id="creditLimit" className="textbox" placeholder="" required onChange={(e) => setState(e.target.value)} />
                                <label for="creditLimit" className={state !="" ? "input-has-value" : ""}>State</label>
                            </div>
                            </div>
                            
                            <div className="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" id="emailId" className="textbox" placeholder="" required onChange={(e) => setZipcode(e.target.value)} />
                                <label for="emailId" className={zipCode !="" ? "input-has-value" : ""}>Zip code</label>
                            </div>
                            </div> */}

                                                        <div className="col-lg-12 loginBtn">
                                                            <Button className="cta-btn btn-smlprimary" style={customButtonStyle} onClick={() => setConfirmationFlag(true)}>Submit</Button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div></div></div></div> </div></div></div>}

                {confirmationFlag &&

                    <div className="popup-box">
                        <div id="" className="CommonModels-box">
                            <div className="Commonfullformblock col-lg-9">
                                <div className="CommonContainer">
                                    <div className="CommonModalcontent">
                                        <div className="CommonModalbody">
                                            <h2>Edit confirmation</h2>
                                            <p>Are you sure,If you want to Add Address Information please confirm</p>
                                        </div>
                                        <div className="CommonModalfooter">
                                            <div className="CommonModalfooter session">
                                                <button className="cta-btn btn-smlprimary" onClick={confirmationPopup} >CANCEL</button>
                                                <button className="cta-btn btn-smlprimary" onClick={onhandleSubmit} >OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                            </div>
                        </div>
                    </div>
                </section>
                {isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />}
            </main>

        </div>
    )
}

export default AddAddress;